import { jsonMember, jsonObject } from 'typedjson';
import { AdminOrderPaymentMethodResponse } from './admin-order-payment-method.response';
import { PaymentStatus } from '@web/shared/module/shop';

@jsonObject
export class AdminOrderPaymentResponse {
  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly status!: PaymentStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminOrderPaymentMethodResponse)
  public readonly method!: AdminOrderPaymentMethodResponse;
}
